import { AnchoredRegion as FASTAnchoredRegion } from '@microsoft/fast-components';
import { foundationAnchoredRegionTemplate as template } from './anchor-region.template';
import { foundationAnchoredRegionStyles as styles } from './anchored-region.styles';
/**
 * @tagname %%prefix%%-anchored-region
 */
export class AnchoredRegion extends FASTAnchoredRegion {
}
// explicitly declaring for extensibility
export const foundationAnchoredRegionShadowOptions = {
    delegatesFocus: true,
    mode: 'open',
};
export const defaultAnchoredRegionConfig = {};
/**
 * The Foundation Anchored Region
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-anchored-region\>
 */
export const foundationAnchoredRegion = AnchoredRegion.compose(Object.assign({ baseName: 'anchored-region', template,
    styles, shadowOptions: foundationAnchoredRegionShadowOptions }, defaultAnchoredRegionConfig));
